"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardQuickSuggestionOption')(function discardQuickSuggestionOption(state) {
    var optionState = state.optionState;
    optionState.smartSuggestionsEnabled = null;
    optionState.browserLocationEnabled = null;
}));
//# sourceMappingURL=discardQuickSuggestionOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/actions/discardQuickSuggestionOption.js
// module id = 5135
// module chunks = 2